<template>
  <layout-view
      navTitle="Фильтры"
  >
    <template v-slot:nav>
      <div class="px-4 pb-2">

        <date-interval name="Интервал" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo" />

        <label-view title="Тип платежа">
            <template v-slot:content>
                <v-list class="pa-0" nav>
                    <v-list-item
                            v-for="key in Object.keys(types)" :key="key"
                            @click="filter.typesSelected.filter((v)=>v===key).length===0 ? filter.typesSelected.push(key) : filter.typesSelected = filter.typesSelected.filter((v)=>v!==key);"
                            class="mb-0"
                    >
                        <v-checkbox :value="filter.typesSelected.filter((v)=>v===key).length>0" class="mb-2" color="primary" dense hide-details="auto" />
                        <div>
                            <v-icon size="18" :color="types[key].color" class="mr-2">{{ types[key].icon }}</v-icon>
                            {{ types[key].name }}
                        </div>
                    </v-list-item>
                </v-list>
            </template>
        </label-view>

        <label-view title="Способ расчета">
            <template v-slot:content>
                <v-list class="pa-0" nav>
                    <v-list-item
                            v-for="key in Object.keys(sources)" :key="key"
                            @click="filter.sourcesSelected.filter((v)=>v===key).length===0 ? filter.sourcesSelected.push(key) : filter.sourcesSelected = filter.sourcesSelected.filter((v)=>v!==key);"
                            class="mb-0"
                    >
                        <v-checkbox :value="filter.sourcesSelected.filter((v)=>v===key).length>0" class="mb-2" color="primary" dense hide-details="auto" />
                        <div>
                            <v-icon size="18" color="type.color" class="mr-2">{{ sources[key].icon }}</v-icon>
                            {{ sources[key].name }}
                        </div>
                    </v-list-item>
                </v-list>
            </template>
        </label-view>

        <device-cash-box-select class="mt-4 mb-4" @selected="(v)=>filter.kktNames = v ? v.split(',') : []" multiple/>

        <insur-select @selected="(i)=>filter.insursSelected = i" class="mb-3" selectAllEnabled/>

        <checkbox-field name="Не подтверждено" class="mb-4" :value.sync="filter.notAccepted"/>

        <text-field name="Сумма" :value.sync="filter.amount"/>

        <text-field name="ID" :value.sync="filter.payId"/>

      </div>
    </template>
    <template v-slot:widgets>
      <v-row class="px-1">
        <v-col cols="4">
          <card-view title="Личный счет" :loading="paySummaryState.isLoading" minHeight="136">
            <template v-if="paySummary!==null" v-slot:content>
              <h2 class="font-weight-medium">{{ $tools.price(paySummary.accountBalance) }}</h2>
            </template>
            <template v-if="paySummary!==null" v-slot:actions>
              <v-row no-gutters>
                <v-col>
                  <v-btn color="green" text block @click="payCreateState.modalOpen()">
                    <v-icon class="mr-2">mdi-arrow-up-circle</v-icon>Пополнить
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn color="red" text block @click="payAccountOutCreateState.modalOpen()">
                    <v-icon class="mr-2">mdi-arrow-down-circle</v-icon>Снять
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn color="blue" text block @click="payAccountTransferCreateState.modalOpen()">
                    <v-icon class="mr-2">mdi-arrow-right-bold-circle</v-icon>Перенести
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </card-view>
        </v-col>
        <v-col cols="2">
          <card-view title="Начислено" :loading="paySummaryState.isLoading" minHeight="136">
            <template v-if="paySummary!==null" v-slot:content>
              <h2 class="font-weight-medium mb-13">{{ $tools.price(paySummary.total) }}</h2>
            </template>
          </card-view>
        </v-col>
        <v-col cols="2">
          <card-view title="Оплачено" :loading="paySummaryState.isLoading" minHeight="136">
            <template v-if="paySummary!==null" v-slot:content>
              <h2 :class="'font-weight-medium'+(paySummary.success===0 ? ' mb-13' : '')">{{ $tools.price(paySummary.success) }}</h2>
            </template>
          </card-view>
        </v-col>
        <v-col cols="2">
          <card-view title="Осталось оплатить" :loading="paySummaryState.isLoading" minHeight="136">
            <template v-if="paySummary!==null" v-slot:content>
              <h2 :class="'font-weight-medium'+(paySummary.wait===0 ? ' mb-13' : '')">
                <v-icon size="21" :color="paySummary.wait===0 ? 'success' : 'warning'" class="position-absolute">
                  {{paySummary.wait===0 ? 'mdi-check-circle' : 'mdi-alert-circle'}}
                </v-icon>
                <span class="ml-7">{{ $tools.price(paySummary.wait) }}</span>
              </h2>
            </template>
            <template v-if="paySummary!==null && paySummary.wait>0" v-slot:actions>
              <v-row no-gutters>
                <v-col>
                  <v-btn @click="$emit('visitsUnpayed')" color="primary" text block>Просмотр</v-btn>
                </v-col>
              </v-row>
            </template>
          </card-view>
        </v-col>
        <v-col cols="2">
          <card-view title="Не подтверждено" :loading="paySummaryState.isLoading" minHeight="136">
            <template v-if="paySummary!==null" v-slot:content>
              <h2 :class="'font-weight-medium'+(paySummary.successNotAccept===0 ? ' mb-13' : '')">
                <v-icon size="21" :color="paySummary.successNotAccept===0 ? 'success' : 'warning'" class="position-absolute">
                  {{paySummary.successNotAccept===0 ? 'mdi-check-circle' : 'mdi-alert-circle'}}
                </v-icon>
                <span class="ml-7">{{ $tools.price(paySummary.successNotAccept) }}</span>
              </h2>
            </template>
            <template v-if="paySummary!==null && paySummary.successNotAccept>0" v-slot:actions>
              <v-row no-gutters>
                <v-col>
                  <v-btn @click="filters={id:null,types:['pay'],sources:[],amount:null,accept:0};load()" color="primary" text block>Просмотр</v-btn>
                </v-col>
              </v-row>
            </template>
          </card-view>
        </v-col>
      </v-row>
    </template>
    <template v-slot:content="{height}">
          <n-table-view
          ref="table"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="[
            { text: 'ID', value: 'id', align: 'start', class:'text-no-wrap'},
            { text: 'Дата', value: 'created', class:'text-no-wrap', sortable: false },
            { text: 'Тип платежа', value: 'type', class:'text-no-wrap', sortable: false },
            { text: 'Способы расчета', value: 'source', class:'text-no-wrap', sortable: false },           
            { text: 'Баланс личного счета', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Банковская карта', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Наличные', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Личный счёт', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Расчётный счет', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Контракт', sortable: false, class:'text-no-wrap text-right'},
            { text: 'ДМС', sortable: false, class:'text-no-wrap text-right'},
            { text: 'ОМС', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Организация', sortable: false, class:'text-no-wrap text-right'},
            { text: 'Сумма', value: 'amount', class:'text-no-wrap', sortable: false },
            { text: 'Комментарий', value: 'comment', class:'text-no-wrap', sortable: false },
            { text: 'Кассир', value: 'operatorUser', class:'text-no-wrap', sortable: false },
            { text: 'Фискальный регистратор', value: 'cashBox', class:'text-no-wrap', sortable: false },
            { text: 'Наименование организации', value: 'insur.name', class:'text-no-wrap', sortable: false },
          ]"
        >
          <template v-slot:item="{item}">
            <tr @click="payId=item.id">
              <td class="text-no-wrap">{{item.id}}</td>
              <td class="text-no-wrap">{{$tools.dateTime(item.created)}}</td>
              <td class="text-no-wrap">
                  <v-icon size="18" class="ml-n1 mr-2" :color="types[item.type].color">{{types[item.type].icon}}</v-icon>
                  {{types[item.type].name}}
              </td>
              <td class="text-no-wrap">
                  <pay-sources :pay="item" compact/>
              </td>
              <td class="text-no-wrap">{{item.type==="internalIn" || item.type==="internalOut" ? '' : $tools.price(item.accountBalance)}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountCard, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountCash, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountAccount, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountBankAccount, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountContract, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountDms, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountOms, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amountInsur, '-')}}</td>
              <td class="text-no-wrap">{{$tools.price(item.amount, '-')}}</td>
              <td class="text-no-wrap">
                <tooltip v-if="!$tools.isEmpty(item.comment)" bottom>              
                  {{$tools.truncateText(item.comment,30)}}
                  <template v-slot:content>
                    <vue-markdown>{{item.comment}}</vue-markdown>
                  </template>
                </tooltip>
              </td>
              <td class="text-no-wrap">
                <UserFullName :user="item.operatorUser" type="admin"/>
              </td>
              <td class="text-no-wrap">
                  <pay-devices :pay="{kktName:item.kktName}"/>
              </td>
              <td class="text-no-wrap">{{item.insur?.name ? item.insur?.name : '-'}}</td>   
            </tr>
          </template>
      </n-table-view>
    </template>
    <template v-slot:footer>
      <pay-create-account-in
          :open="payCreateState.isModalOpen"
          :userId="$router.currentRoute.params.id"
          @complete="payCreateState.modalClose();loadPaySummary();$refs.table.load(true)"
      />
      <pay-create-account-out
          :open="payAccountOutCreateState.isModalOpen"
          :userId="$router.currentRoute.params.id"
          @complete="payAccountOutCreateState.modalClose();loadPaySummary();$refs.table.load(true)"
      />
      <pay-create-account-transfer
          :open="payAccountTransferCreateState.isModalOpen"
          :userId="$router.currentRoute.params.id"
          @complete="payAccountTransferCreateState.modalClose();loadPaySummary();$refs.table.load(true)"
      />
      <pay :id="payId" @cancel="payId=null;loadPaySummary();$refs.table.load(true)"/>
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import NTableView from "@/componentsV2/base/NTableView.vue";
import CardView from "@/components/CardView";
import Pay from "@/views/Pay/Pay";
import moment from "moment";
import LayoutView from "@/components/LayoutView";
import PayCreateAccountIn from "@/views/Pay/PayCreateAccountIn.vue";
import PaySources from "@/views/Pay/components/PaySources.vue";
import PayDevices from "@/views/Pay/components/PayDevices.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import LabelView from "@/components/LabelView.vue";
import InsurSelect from "@/views/Insur/components/InsurSelect.vue";
import DeviceCashBoxSelect from "@/views/Device/component/DeviceCashBoxSelect.vue";
import PayCreateAccountOut from "@/views/Pay/PayCreateAccountOut.vue";
import PayCreateAccountTransfer from "@/views/Pay/PayCreateAccountTransfer.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";

import {
  Entity_User,
  Entity_Pay,
  Entity_Insur
} from "../../../../EntityStoreCacheService";

export default {
  components: {
    PayCreateAccountTransfer,
    PayCreateAccountOut,
    DeviceCashBoxSelect, InsurSelect, LabelView,
    NTableView, UserFullName, PayDevices,
    PaySources,
    PayCreateAccountIn,
    LayoutView,
    CardView, 
    Pay,
    Tooltip, 
    DateInterval,
    TextField,
    CheckboxField
  },
  data: () => ({
    paySummaryState: new State(),
    paySummary:null,
    dateFrom:null,
    dateTo:null,
    types:Api.model.Pay.types,
    sources:Api.model.Pay.sources,
    payId:null,

    filter: {
      dateFrom:null,
      dateTo:null,
      typesSelected:[],
      sourcesSelected:[],
      insursSelected:[],
      kktNames: [],
      notAccepted: false,
      amount: null,
      payId: null
    },
    payCreateState: new State(),
    payAccountOutCreateState: new State(),
    payAccountTransferCreateState: new State(),
  }),
  mounted() {
    this.loadPaySummary();
  },
  watch:{
    filter: {
      deep: true,
      handler () {
        this.$refs.table.load();
        this.loadPaySummary();
      },
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Pay()
      .selects(Entity_Pay.id)
      .selects(Entity_Pay.type)
      .selects(Entity_Pay.amount)
      .selects(Entity_Pay.amountPayed)
      .selects(Entity_Pay.amountCash)
      .selects(Entity_Pay.amountCard)
      .selects(Entity_Pay.amountBankAccount)
      .selects(Entity_Pay.amountAccount)
      .selects(Entity_Pay.amountOms)
      .selects(Entity_Pay.amountDms)
      .selects(Entity_Pay.amountContract)
      .selects(Entity_Pay.accountBalance)
      .selects(Entity_Pay.kktName)
      .selects(Entity_Pay.terminalName)
      .selects(Entity_Pay.tranId)
      .selects(Entity_Pay.comment)
      .selects(Entity_Pay.created)
      .selects(Entity_Pay.isAcceptBankAccount)
      .selects(Entity_Pay.isAcceptOms)
      .selects(Entity_Pay.isAcceptDms)
      .selects(Entity_Pay.isAcceptContract)

      .selects([Entity_Pay.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.operatorUser, Entity_User.id].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.insur, Entity_Insur.id].join('.'))
      .selects([Entity_Pay.insur, Entity_Insur.name].join('.'))

      .filterAnd([Entity_Pay.entity, Entity_Pay.user, Entity_User.id].join('.') + ' =?',this.$router.currentRoute.params.id)

      if(this.filter.dateFrom)  
        rb.filterAnd([Entity_Pay.entity, Entity_Pay.created].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
      
      if(this.filter.dateTo) 
        rb.filterAnd([Entity_Pay.entity, Entity_Pay.created].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));


      if (!this.$tools.isEmpty(this.filter.typesSelected))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.type].join('.')+' in (?)',this.filter.typesSelected);

      if (!this.$tools.isEmpty(this.filter.sourcesSelected)){
        let query = '';

        this.filter.sourcesSelected.forEach((source,idx)=>{
            let key = 'amount'+source[0].toUpperCase() + source.slice(1);
            let part = [Entity_Pay.entity, Entity_Pay[key]].join('.')+' > 0'

            query+= part
            if (idx!==this.filter.sourcesSelected.length-1)
              query+=' OR '
        })
        rb.filterAnd(query)
      }
        
      if (!this.$tools.isEmpty(this.filter.insursSelected))
          rb.filterAnd([Entity_Pay.entity, Entity_Pay.insur, Entity_Insur.id].join('.')+' in (?)', this.filter.insursSelected.map(i=>i.id))

      if (!this.$tools.isEmpty(this.filter.kktNames))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.kktName].join('.')+' in (?)',this.filter.kktNames);

      if (this.filter.notAccepted) {
        rb.filterAnd(
        [Entity_Pay.entity, Entity_Pay.amountBankAccount].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptBankAccount].join('.')+' = false OR '+ 
        [Entity_Pay.entity, Entity_Pay.amountContract].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptContract].join('.')+' = false OR '+ 
        [Entity_Pay.entity, Entity_Pay.amountDms].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptDms].join('.')+' = false OR '+ 
        [Entity_Pay.entity, Entity_Pay.amountOms].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptOms].join('.')+' = false')
      }

      if (!this.$tools.isEmpty(this.filter.amount))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.amount].join('.')+' =?',this.filter.amount);

      if (!this.$tools.isEmpty(this.filter.payId))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.id].join('.')+' =?',this.filter.payId);


      rb.page(page).onPage(onPage)

      sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
      })

      // rb.addStateCallback((v) => {
      //   this.loadState.setRequestBuilderState(v)
      // })

      return rb;
    },
    loadPaySummary(){
      this.paySummaryState.stateLoading();
      Api.service.pay.paySummary(
          this.$router.currentRoute.params.id,
          this.dateFrom,
          this.dateTo,
          (v) => {
            this.paySummary = v;
            this.paySummaryState.stateSuccess();
          }, () => {
            this.paySummaryState.stateError();
          });
    },
  }
}
</script>